import styled from 'styled-components'

export const Container = styled.div`
  margin: 8px;

  & .title {
    font-weight: 600;
    margin-bottom: 4px;
  }

  & .warning {
    font-size: 12px;
    color: #8a5a00;
    background: #fff3cd;
    border: 1px solid #fbaf1d;
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 12px;
  }

  & .row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  & .dayField {
    min-width: 96px;
  }
`
